import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  EventEmitter,
  Output
} from '@angular/core';
import { camelize } from '@app/utils';
import { Roles } from '@app/models/user';
import { select, Store } from '@ngrx/store';
import {
  getShipmentFOB,
  getShipmentsTotalFob,
  getShipmentsUnits
} from '@app/formulas.utils';
import * as fromProductCountry from '@core/reducers/product-country.reducer';
import * as fromSelectedFollow from '@app/modules/follow/reducers/follow.reducer';

@Component({
  selector: 'app-country-units',
  templateUrl: './country-units.component.html',
  styleUrls: ['./country-units.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CountryUnitsComponent implements OnInit {
  @Input() form;
  @Input() unitsFieldsGroups = [];
  @Input() business;
  @Input() product;
  @Input() productCountry;
  @Input() productShipments;
  @Output() editMetadata = new EventEmitter();

  constructor(private store: Store<any>) {}

  totalChains;
  _alert = true;
  squareUnits = false;
  productmirror;
  productCountryMirrors$ = this.store.pipe(
    select(fromProductCountry.getProductCountryMirrors)
  );
  follows$ = this.store.pipe(select(fromSelectedFollow.getPopulated));
  follow;

  ngOnInit() {
    this.productCountryMirrors$.subscribe(x => {
      const filteredPm = x.filter(x2 => x2.id === this.productCountry.id);
      if (filteredPm.length) {
        this.productmirror = filteredPm[0];
      } else {
        this.productmirror = {};
      }
    });

    this.follows$.subscribe(item => {
      this.follow = item;
    });
  }

  fieldsTotal(fields) {
    const total = fields.reduce(
      (sum, field) =>
        (sum +=
          parseInt(this.form.get('metadata').get(field.fieldName).value, 10) ||
          0),
      0
    );

    this.totalChains = total;

    return total;
  }

  closeAlert() {
    this.squareUnits = false;
    this._alert = !this._alert;
  }

  changeUnits() {
    this.squareUnits = true;
  }

  get getCountryDepartmentId() {
    return this.productCountry.CountryDepartmentId;
  }

  getChainData(source, chain) {
    const fields = source && source.fields;
    if (fields) {
      const results = fields.find(f => f.fieldName.indexOf(chain.prefix) === 0);
      return results;
    }
  }

  getData(source, chain) {
    const fields = source && source.fields;
    if (fields) {
      const results = fields.find(f => f.fieldName.indexOf(chain.prefix) === 0);
      return results;
    }
  }

  getValue(data) {
    return this.productmirror && this.productmirror.metadata
      ? this.productmirror.metadata[data]
      : this.productCountry.metadata[data] || 0;
  }

  fieldsTotalMirror(fields) {
    const total = fields.reduce(
      (sum, field) =>
        (sum +=
          parseInt(
            this.productmirror && this.productmirror.metadata
              ? this.productmirror.metadata[field.fieldName]
              : this.productCountry.metadata[field.fieldName],
            10
          ) || 0),
      0
    );

    this.totalChains = total;

    return total;
  }

  get followStatusValid() {
    const status = this.follow.status;
    if (
      status === 2 ||
      status === 3 ||
      status === 5 ||
      status === 7 ||
      status === 8
    ) {
      return true;
    } else {
      return false;
    }
  }

  get imu() {
    let pvp;
    let result = 0;
    let netSale = 0;
    let costSale = 0;
    let totalFob;
    let pc;
    let totalUnits;
    let weightedFOB;

    let currentFactor = this.follow.Factors.filter(
      x => x.CountryId === this.productCountry.CountryId
    );

    const currentTax = this.follow.Taxes.filter(
      x => x.CountryId === this.productCountry.CountryId
    );
    const currentExchangeRate = this.follow.ExchangeRates.filter(
      x => x.CountryId === this.productCountry.CountryId
    );

    if (this.productCountry.metadata.pvp) {
      pvp = this.productCountry.metadata.pvp;
    }

    const [currentBusiness] = this.follow.Businesses.filter(
      x =>
        x.CountryId === this.productCountry.CountryId &&
        x.code === this.productCountry.businessUnit
    );

    if(currentBusiness){
      currentBusiness.Chains.map(x => {
        let discount = this.productCountry.metadata[
          camelize(`${x.prefix} Discount ${this.productCountry.businessUnit}`)
        ];
        let units = this.productCountry.metadata[
          camelize(`${x.prefix} Units ${this.productCountry.businessUnit}`)
        ];
  
        if (currentTax.length > 0) {
          netSale += units * (pvp / (currentTax[0].value * 0.01 + 1));
        }
      });
    }

    if (
      this.product &&
      this.productCountry &&
      this.follow &&
      this.productShipments
    ) {
      totalFob = getShipmentsTotalFob(
        this.product,
        this.productCountry,
        this.follow.type,
        [],
        this.productShipments
      );

      totalUnits = getShipmentsUnits(this.productShipments);
    } else {
      totalUnits = 0;
      totalFob = 0;
    }

    if ( currentFactor[0] && this.productCountry && this.productCountry.factor) {
      currentFactor[0].value = this.productCountry.factor;
    }

    weightedFOB = totalFob / totalUnits;

    if (currentExchangeRate.length > 0 && currentFactor.length > 0) {
      costSale =
        weightedFOB *
        currentExchangeRate[0].value *
        currentFactor[0].value *
        totalUnits;
    }

    const contribution = netSale - costSale;

    if (contribution) {
      return contribution / netSale;
    }

    return 0;
  }
}
